const style = (theme) => {
  const output = {
    root: {
      fontSize: 12,
      letterSpacing: 1,
      textTransform: 'uppercase',
      display: 'inline-block',
      padding: '8px 30px',
      borderRadius: 20,
      color: theme.colors[1],
      background: theme.colors[2],
      verticalAlign: 'middle',
      transition: `background .3s ${theme.easings['power4.out']}, color .3s ${theme.easings['power4.out']}`,
      cursor: 'pointer',
      '& span': {
        display: 'block',
        lineHeight: 1,
      },
    },
    btnDark: {
      color: theme.colors[1],
      background: theme.colors[2],
      '& svg': {
        fill: theme.colors[1],
      },
      '&:hover': {
        background: theme.colors[6],
        color: theme.colors[2],
        '& svg': {
          fill: theme.colors[2],
        },
        '& a': {
          color: theme.colors[2],
        },
      },
      '& a': {
        color: theme.colors[1],
      },
    },
    btnGrey: {
      color: theme.colors[1],
      background: theme.colors[0],
      '& svg': {
        fill: theme.colors[1],
      },
      '&:hover': {
        background: theme.colors[2],
        color: theme.colors[1],
        '& svg': {
          fill: theme.colors[1],
        },
        '& a': {
          color: theme.colors[1],
        },
      },
      '& a': {
        color: theme.colors[1],
      },
    },
    btnLight: {
      color: theme.colors[2],
      background: theme.colors[1],
      '& svg': {
        fill: theme.colors[2],
      },
      '&:hover': {
        background: theme.colors[7],
        color: theme.colors[1],
        '& svg': {
          fill: theme.colors[1],
        },
        '& a': {
          color: theme.colors[1],
        },
      },
      '& a': {
        color: theme.colors[2],
      },
    },
    btnRed: {
      color: theme.colors[1],
      background: '#E31111',
      '& svg': {
        fill: theme.colors[1],
      },
      '&:hover': {
        background: theme.colors[1],
        color: theme.colors[2],
        '& svg': {
          fill: theme.colors[2],
        },
        '& a': {
          color: theme.colors[2],
        },
      },
      '& a': {
        color: theme.colors[1],
      },
    },
    btnGreen: {
      color: theme.colors[2],
      background: '#00FF93',
      '& svg': {
        fill: theme.colors[2],
      },
      '&:hover': {
        background: theme.colors[1],
        color: theme.colors[2],
        '& svg': {
          fill: theme.colors[2],
        },
      },
    },
    withIcons: {
      display: 'flex',
      alignItems: 'center',
      '& > a': {
        display: 'flex',
        alignItems: 'center',
      },
      '& svg': {
        marginRight: 10,
        height: 10,
        width: 9,
        transition: `all .3s ${theme.easings['power4.out']}`,
        '&.download': {
          transform: 'rotate(-90deg)',
        },
      },
    },
  }

  return output
}

export default style
